import { render, staticRenderFns } from "./InstallButton.vue?vue&type=template&id=76e58eca&scoped=true&"
import script from "./InstallButton.vue?vue&type=script&lang=js&"
export * from "./InstallButton.vue?vue&type=script&lang=js&"
import style0 from "./InstallButton.vue?vue&type=style&index=0&id=76e58eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e58eca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
